module.exports = __webpack_public_path__ + "media/images/icons/checked-2dd7854659aa4241f86c0b34c9d9e25d.svg";